import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import PriceLevelsList from 'components/PriceLevels/List'

import { loadSalesEventTypes } from 'store/SalesEventTypes/actions'
import { getCurrentVenueUuid } from 'store/Venues/selector'

const PriceLevels = () => {
  const dispatch = useDispatch()
  const currentVenueUuid = useSelector(getCurrentVenueUuid)

  useEffect(() => {
    dispatch(loadSalesEventTypes(currentVenueUuid))
  }, [dispatch, currentVenueUuid])

  return (
    <div className="items">
      <div className="header">
        <ul className="header__menu">
          <li className="header__menu-item">Name</li>
          <li className="header__menu-item">OFF | ON</li>
        </ul>
      </div>
      <PriceLevelsList />
    </div>
  )
}

export default PriceLevels
